<template>
    <Accordion />
    <MeasurementSwitch />
    <Seeds />
    <CalculationSwitch />
    <Form />
    <Calculation />
</template>

<script setup>
import { onMounted } from "vue";
import { useSeedRateCalculatorStore } from './store/store.js';
import Accordion from "./components/Accordion.vue";
import CalculationSwitch from "./components/CalculationSwitch.vue";
import MeasurementSwitch from "./components/MeasurementSwitch.vue";
import Seeds from "./components/Seeds.vue";
import Form from "./components/Form.vue";
import Calculation from "./components/Calculation.vue";

const store = useSeedRateCalculatorStore();

onMounted(() => {
  store.getTranslationsAction();
  store.getCropsAction();
  store.getCurrentLanguage();
})

</script>